import * as TYPES from './types';

const initialState = {
  list: [],
  fetching: false,
  total: 0,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TYPES.GET_PRE_PROCESSED_DOCUMENTS_REQUEST:
      return { ...state, fetching: true, errorFetching: false };

    case TYPES.DELETE_PRE_PROCESSED_DOCUMENT_REQUEST:
      return { ...state, fetching: true };

    case TYPES.GET_PRE_PROCESSED_DOCUMENTS_ERROR:
    case TYPES.DELETE_PRE_PROCESSED_DOCUMENT_ERROR:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
      };

    case TYPES.GET_PRE_PROCESSED_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        total: payload.total,
        list: [...payload.preProcessedDocuments],
        fetching: false,
      };
    }

    case TYPES.DELETE_PRE_PROCESSED_DOCUMENT_SUCCESS: {
      const list = state.list;
      const index = list.findIndex((item) => item.id === payload);
      if (index !== -1) list.splice(index, 1);
      return {
        ...state,
        list,
        fetching: false,
        total: state.total - 1,
      };
    }

    default:
      return { ...state };
  }
};

export default reducer;
